// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';
import { Actions, ActionTypes } from './actions';
import { initialState, PermissionState } from './state';

/**
 * This effect is for listen master permission actions, execute auth service call and dispatch in master permission reducer.
 * For master permission api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/4/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created master permission effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): PermissionState {
  switch (action.type) {
    // PERMISSION_COMMON ACTION METHOD
    case ActionTypes.PERMISSION_COMMON: {
      return state;
    }
    // PERMISSION_COMMON_SUCCESS ACTION METHOD
    case ActionTypes.PERMISSION_COMMON_SUCCESS: {

      // commonly store and handle all master permission modules
      if (action.response.common.INDIVIDUAL) {
        const response = get(action.response.data, action.response.common.API_RESPONSE);
        return {
          ...state,
          [action.response.common.STATE]: {
            ...state[action.response.common.STATE],
            [response[action.response.common.UNIQUE_KEY]]: response,
          },
        };
      }

      // store as normal way
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      console.log('logout');
      return initialState;
    }

    // DEFAULT
    default:
      return state;
  }
}
